export default __webpack_public_path__ + "static/media/icon_Globe.8be55fca.png";